export default __webpack_public_path__ + "static/media/epsaNew.f8c5a12b.png";